import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import useMedicineStore from '../../zustandstores/medicinecart.store';

const MedQtyBtn = ({medicineID}) => {
    const cartTracker = useMedicineStore(state => state.cartTracker);
    const incItemQty = useMedicineStore(state => state.incItemQty);
    const decItemQty = useMedicineStore(state => state.decItemQty);
    const cartItem = cartTracker.get(medicineID);
    const maxCountReached = cartItem.qty >= 4;

    const incQty = () => {
        if (maxCountReached) return;
        incItemQty(medicineID);
    };
    const decQty = () => {
        decItemQty(medicineID);
    };
    return (
        <div className='med-qty-btn-container'>
            <IconButton color="primary" onClick={decQty}>
                <RemoveIcon />
            </IconButton>
            {cartItem.qty}
            <IconButton color="primary" onClick={incQty} disabled={maxCountReached}>
                <AddIcon />
            </IconButton>
        </div>
    );
};

export default MedQtyBtn;
MedQtyBtn.propTypes = {
    medicineID: PropTypes.number.isRequired
};